module.exports = __webpack_public_path__ + "static/media/step3.3fc5d048.svg";